import { render } from "./labelMaketing.vue?vue&type=template&id=5c4ebc50&scoped=true"
import script from "./labelMaketing.vue?vue&type=script&lang=js"
export * from "./labelMaketing.vue?vue&type=script&lang=js"

import "./labelMaketing.vue?vue&type=style&index=0&id=5c4ebc50&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4ebc50"]])

export default __exports__